import PrepaidHealthWrapper from "@mediline/mediline-api-middleware/src/wrappers/prepaid.health.wrapper";

const phw = new PrepaidHealthWrapper();


export const GetPrepaidHealth = async (userToken, displayError = null) => await phw.getPrepaidHealth(userToken, displayError);


export const GetPrepaidHealthCategory = async (userToken, params, displayError = null) => phw.getPrepaidHealthCategoryByPrepaidHealth(userToken, params, displayError);
